import {StoreBase} from "shared/utilities/Store/StoreBase";
import {observable} from "mobx";
import {CurrencyPositionEnum} from "PageBuilder/pagebuilder/PDFDocument.Options";

export class CurrencySettings extends StoreBase{
    @observable
    Symbol:string;
    @observable
    Position:CurrencyPositionEnum;
    @observable
    ThousandSeparator:string;
    @observable
    DecimalSeparator:string;
    @observable
    NumberOfDecimals:number;

    protected LoadDefaultValues() {
        this.Symbol='$';
        this.Position=CurrencyPositionEnum.Left;
        this.ThousandSeparator=',';
        this.DecimalSeparator='.';
        this.NumberOfDecimals=2;
    }
}
